import { useEffect } from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import { useAuth0 } from 'lib/auth'
import config, { routes } from 'config'
import {
  Button,
  ButtonProps,
  Card,
  Col,
  Form,
  Input,
  Row,
  Space,
} from 'components/common'

type TenantButtonProps = Omit<ButtonProps, 'type' | 'size' | 'block'>

const TenantButton = (props: TenantButtonProps): JSX.Element => (
  <Button type="primary" htmlType="submit" size="large" block {...props} />
)

type FormValues = {
  organizationId: string
  organizationName: string
}

interface LoginSelectionProps {
  selectionList: { id: string; displayName: string }[]
}

export const LoginSelection = ({
  selectionList,
}: LoginSelectionProps): JSX.Element => {
  const { loginWithRedirect, isLoading, isAuthenticated, user } = useAuth0()

  useEffect(() => {
    if (isLoading) {
      // Do not anything
    } else if (isAuthenticated) {
      if (user) {
        if (config.auth0.observers.some((org) => org.id === user.orgId)) {
          navigate('/calendar')
        } else {
          navigate(routes.home)
        }
      }
    } else {
      // Do not anything
    }
  }, [isLoading, isAuthenticated, user])

  const onFinish = ({ organizationId }: FormValues): void => {
    loginWithRedirect({ organization: organizationId })
  }

  return (
    <>
      {isLoading === false && isAuthenticated === false && (
        <div className={clsx('grid', 'place-items-center', 'h-screen')}>
          <Card title="ログインするテナントを選択してください" shadow>
            <Row justify="center">
              <Col>
                <Space direction="vertical">
                  {selectionList.map(({ id, displayName }) => (
                    <Form key={id} component="form" onFinish={onFinish}>
                      <Form.Item name="organizationId" initialValue={id} hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item>
                        <TenantButton>{displayName}</TenantButton>
                      </Form.Item>
                    </Form>
                  ))}
                </Space>
              </Col>
            </Row>
          </Card>
        </div>
      )}
    </>
  )
}
